import type { NetworkPayload } from "../../../composites";
import type { WebDocument } from "./types";

export const API = {
  fetchAccountDocuments: (
    accountIds: API.AccountId[],
    after?: number,
  ): NetworkPayload => {
    const params = new URLSearchParams({ account_uuids: accountIds.join(",") });
    if (after !== undefined) {
      params.set("after", after.toString());
    }
    return {
      url: `documents?${params.toString()}`,
      options: {
        method: "GET",
      },
    };
  },
  createShareDocuments: (
    documents: WebDocument[],
  ): NetworkPayload<{ documents: WebDocument[] }> => {
    return {
      url: "documents/download?share=1",
      options: {
        method: "POST",
        payload: { documents },
        isJsonResponse: true,
      },
    };
  },
};
